import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react';
import { useAppSelector } from './redux';
import { Color } from '../redux/actions/colorsActions/types';

export function useDefaultColor(trigger = true): [Color | null, Dispatch<SetStateAction<Color | null>>] {
    const [color, setColor] = useState<Color | null>(null);

    const additionalColors = useAppSelector((s: any) => s.colorsReducer.additionalColors as Color[][]);
    const blue3 = useMemo(
        () => additionalColors?.flat?.()?.find((c) => c.name === 'Blue 3') ?? null,
        [additionalColors],
    );

    useEffect(() => {
        if (trigger && blue3 && !color) {
            setColor(blue3);
        }
    }, [trigger, blue3, color]);

    return [color, setColor];
}
